import { forwardRef } from 'react'
import AppLoader from '../../../features/appLoader/AppLoader'
import { useForceRoomSelection } from '../../../../hooks/useForceRoomSelection'
import StartHeader from '../startHeader/StartHeader'
import StartRoom from '../startRoom/StartRoom'
import StartBody from '../startBody/StartBody'
import { useApplicationCallbacks } from '../../../../providers/application-callbacks'
import { MAIN, CREATING } from '../../../../constants/shared/states/names'
import { useUser } from '../../../../redux/reducer/user'
import { GTMStart } from '../../../../constants/analytics/GTM'
import { useModal } from '../../../../hooks/useModal'
import useStateControls from '../../../../hooks/useStateControls'
import { useFeatureToggle } from '../../../../hooks/useFeatureToggle'
import { getSelectCountryModalProps } from '../../../../constants/country'
import { useLanguageControls } from '../../../../hooks/useLanguageControls'
import { useTranslation } from '../../../../translations'

const Start = forwardRef(function (_, ref) {
  const { isFirstEntry, profile } = useUser()
  const callbacks = useApplicationCallbacks()
  const { t } = useTranslation()
  const { language } = useLanguageControls()
  const { setState } = useStateControls()
  const { addModal } = useModal()
  const gameTamagotchiEnableCountrySelect = useFeatureToggle('gameTamagotchiEnableCountrySelect')
  const shouldShowCountryFeature = gameTamagotchiEnableCountrySelect

  const nextState = isFirstEntry ? CREATING : MAIN

  const checkCountrySelected = () => {
    if (!shouldShowCountryFeature) return true
    return Boolean(profile?.userCountry)
  }

  const toMain = () => {
    // Проверяем, нужно ли показать модалку выбора страны
    if (shouldShowCountryFeature && !checkCountrySelected()) {
      addModal({
        type: 'selectCountryModal',
        props: {
          ...getSelectCountryModalProps({
            t,
            profile,
            language,
          }),
          isGameStopped: false,
        },
      })
      return
    }

    GTMStart()

    if (!isFirstEntry) callbacks.addOutsideAnimations([{ state: nextState, animation: 'hello' }])

    setState(nextState)
  }

  const { isPending: isPendingChangeRoom } = useForceRoomSelection({ callbacks })

  return (
    <section
      className={'start'}
      ref={ref}
      onClick={toMain}
    >
      <div className={'start__content'}>
        <StartHeader />

        <StartRoom />

        <StartBody />
      </div>

      {isPendingChangeRoom && <AppLoader />}
    </section>
  )
})
export default Start
